import React, { Component } from 'react';

import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import './styles.css';

import * as FileSaver from 'file-saver';


class AltVendorTable extends Component {

    constructor(props) {
        super(props)   

        this.state = {
            data: [],
            handleTableData: [],
            isFirstTimeSearch: true,
            lastDataTable: [],
            show: false,
            currentPage: 1,
            todosPerPage: 7,
            pageNumbers: [],
            selectedRow: -1,
            currentPagination: 1,
            paginationLimit: 7,
        };  
        this.cancelArray = [];
    }

    exportToCSV = async (csvData) => {

        const XLSX = await import("xlsx");
        
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';

        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'Alt-vendor-file' + fileExtension);
    }


    componentWillReceiveProps(nextProps) {
        if(nextProps.filterItem && nextProps.type == "item")  return this.filterItem(nextProps.filterItem);
        if(nextProps.filterAltVendor && nextProps.type == "vendor")   return this.filterAltVendor(nextProps.filterAltVendor);
        if(nextProps.responseData.length !== 0 && this.state.data.length === 0) {
            return this.formatDataResponse(nextProps);  
        } 
        if(this.state.data.length !== nextProps.responseData.length) {
            return this.formatDataResponse(nextProps);  
        }
        if(this.state.data.length === nextProps.responseData.length && (!nextProps.filterItem && !nextProps.filterAltVendor)) {
            return this.formatDataResponse(nextProps);  
        }
    }

    formatDataResponse = (dataMoq) => {
        dataMoq.responseData.map((data, index) => {
            data.changeSku = false;
            data.changeAltVendorNumber = false;
            data.changeWhse = false;
            data.changeNipoBase = false;
            data.changeNipoCore = false;
            data.changeAvailableInventory = false;
            data.changeAnnualCommitment = false;
            data.changeRemainingAvailable = false;
            data.changeUnitsPerCase = false;
            data.changeCasesPerTier = false;
            data.changeTiersPerPallet = false;
            data.changeCompanyPOQ = false;
            data.changeExpirationDate = false;
            data.checked = false;
            data.masterIndex = index;
        });
       
        let pages = [];
        for (let i = 1; i <= Math.ceil(dataMoq.responseData.length / this.state.todosPerPage); i++) {
            pages.push(i);
        }
        this.setState({pageNumbers: pages})
        this.setState({data: dataMoq.responseData, show: true})        
    }

    filterItem = (item) => {
        if(this.state.isFirstTimeSearch === true) {
            const data  = JSON.parse(JSON.stringify(this.state.data));
            this.setState({handleTableData: data});
        } 
        if(item === '') {
            let pages = [];
            for (let i = 1; i <= Math.ceil(this.state.handleTableData.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: this.state.handleTableData, pageNumbers: pages})        
        } else {
            let result = this.filteredTableItem(item);
            let pages = [];
            for (let i = 1; i <= Math.ceil(result.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: result,  pageNumbers: pages});
            if(result.length !== 0) this.setState({lastDataTable: result})
            this.state.isFirstTimeSearch = false;
        }     
    }

    filteredTableItem = function (search) {
        if(this.state.data !== undefined && this.state.data.length > 0) {
            let filtered = this.state.data.filter(item => String(item.sku).startsWith(search)); 
            return filtered;
        } else {
            const backupData = this.state.lastDataTable
            return backupData;
        }   
    }

    filterAltVendor = (vendor) => {
        if(this.state.isFirstTimeSearch === true) {
            const data  = JSON.parse(JSON.stringify(this.state.data));
            this.setState({handleTableData: data});
        } 
        if(vendor === '') {
            let pages = [];
            for (let i = 1; i <= Math.ceil(this.state.handleTableData.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: this.state.handleTableData,  pageNumbers: pages})        
        } else {
            let result = this.filteredTableVendor(vendor);
            let pages = [];
            for (let i = 1; i <= Math.ceil(result.length / this.state.todosPerPage); i++) {
                pages.push(i);
            }
            this.setState({data: result,  pageNumbers: pages});
            if(result.length !== 0) this.setState({lastDataTable: result})
            this.state.isFirstTimeSearch = false;
        }  
    }

    filteredTableVendor = function (search) {
        if(this.state.data !== undefined && this.state.data.length > 0) {
            let filtered = this.state.data.filter(item => String(item.alternateVendorNumber).startsWith(search)); 
            return filtered;
        } else {
            const backupData = this.state.lastDataTable
            return backupData;
        }   
    }

    handleClick = (number) => {
        const pageNumber = number;
        this.setState({
          currentPage: pageNumber
        });
    }

    onCancel = (data, index) => {
        const cancelArray = this.cancelArray.map(data => {
            if(data.cancelFlag === 'N') {
                data.cancelFlag = 'Y';    
            } else {
                data.cancelFlag = 'N';
            }    
            return data;   
        });
        this.setState({data: this.state.data});
    }

    sendMoq = (item) => {
        this.props.itemSend(item);
    }

    sendDeleteMoq = (item) => {
        this.props.itemDelete(item);
    }

    handleClickPagination = (number) => {
        if(this.state.pageNumbers.length > 0) {
            if(typeof(number) === 'number') {
                const pageNumber = this.state.currentPagination + number;
                const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                if(pageNumber > 0 && pageNumber <= limitPagination) {
                    this.setState({
                        currentPagination: pageNumber
                    });
                }
            } else {
                if(number === 'first') {
                    this.setState({
                        currentPagination: 1
                    });
                } else {
                    const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                    this.setState({
                        currentPagination: limitPagination
                    });
    
                }
            }   
        }
    }

    onCheckboxChange = (data, index) => {
        if(data.checked == false) {
            data.index = this.cancelArray.length == 0? 0 : this.cancelArray.length;
            data.checked = true;
            this.cancelArray.push(data)
            
        } else {
            data.checked = false;
            const indexArray = this.cancelArray.findIndex(obj => obj.index == data.index);
            this.cancelArray.splice(indexArray, 1);
        }
        this.sendDeleteMoq(this.cancelArray);
        this.setState({data: this.state.data});
    }

    onCheckboxSelectAllChange(event) {
        if(event.target.checked === true) {
            const allArray = this.state.data;
            allArray.map(obj => {
                obj.checked = true;
            });
            this.cancelArray = allArray;
        } else {
            const allArray = this.state.data;
            allArray.map(obj => {
                obj.checked = false;
            });
            this.cancelArray = [];
        }
        this.sendDeleteMoq(this.cancelArray);
        this.setState({data: this.state.data});        
    }

    onExportToExcel = (data) => {
        let csvData;
        if(this.cancelArray.length > 0) {
            csvData = JSON.parse(JSON.stringify(this.cancelArray))
        } else if(data != null){
            csvData = JSON.parse(JSON.stringify(data));
        } else {
            csvData = JSON.parse(JSON.stringify(this.state.data));
        }
        csvData.map(data => {
            data.itemVendorMoq = data.diItemVendorMoq;
            data.itemVendorMultiple = data.diItemVendorDCMoq;
            delete data.diItemVendorDCMoq;
            delete data.diItemVendorMoq;
            delete data.index;
            delete data.masterIndex;
            delete data.checked;   
            delete data.changeCompanyPOQ;
            delete data.changeTiersPerPallet;
            delete data.changeCasesPerTier;
            delete data.changeUnitsPerCase;
            delete data.changeRemainingAvailable;
            delete data.changeAnnualCommitment;
            delete data.changeAvailableInventory;
            delete data.changeNipoCore;
            delete data.changeNipoBase;
            delete data.changeWhse;
            delete data.changeAltVendorNumber;
            delete data.changeSku;
            delete data.changeExpirationDate;
        });
        this.exportToCSV(csvData);
    }

    onDeleteData = () => {
        this.cancelArray = [];
    }

    handleSkuChange = (e, data) => {
        const value = e.target.value;
        data.sku = value;
        data.changeSku = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleVendorNumberChange = (e, data) => {
        const value = e.target.value;
        data.alternateVendorNumber = value;
        data.changeAltVendorNumber = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleWhseChange = (e, data) => {
        const value = e.target.value;
        data.whse = value;
        data.changeWhse = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleNipoBaseChange = (e, data) => {
        const value = e.target.value;
        data.nipoBaseCost = value;
        data.changeNipoBase = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleNipoCoreChange = (e, data) => {
        const value = e.target.value;
        data.nipoCoreCost = value;
        data.changeNipoCore = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleAvailableInventoryChange = (e, data) => {
        const value = e.target.value;
        data.availableInventory = value;
        data.changeAvailableInventory = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleAnnualCommitmentChange = (e, data) => {
        const value = e.target.value;
        data.annualCommitment = value;
        data.changeAnnualCommitment = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleRemainingAvailableChange = (e, data) => {
        const value = e.target.value;
        data.remainingAvailable = value;
        data.changeRemainingAvailable = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleUnitsPerCaseChange = (e, data) => {
        const value = e.target.value;
        data.unitsPerCase = value;
        data.changeUnitsPerCase = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleCasesPerTierChange = (e, data) => {
        const value = e.target.value;
        data.casesPerTier = value;
        data.changeCasesPerTier = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handlTiersPerPalletChange = (e, data) => {
        const value = e.target.value;
        data.tiersPerPallet = value;
        data.changeTiersPerPallet = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleCompanyPOQChange = (e, data) => {
        const value = e.target.value;
        data.companyPOQ = value;
        data.changeCompanyPOQ = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    handleExpirationDateChange = (e, data) => {
        const value = e.target.value;
        data.expirationDate = value;
        data.changeExpirationDate = true;
        let fullObject = JSON.parse(JSON.stringify(this.state.data));
        this.setState({data: fullObject});
        this.sendMoq(fullObject);
    }

    render() {    

        const { currentPage, todosPerPage } = this.state;

        // Logic for displaying current todos
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

        //Pagination logic

        const { currentPagination, paginationLimit } = this.state;

        const indexOfLastPagination = currentPagination * paginationLimit;
        const indexOfFirstPagination = indexOfLastPagination - paginationLimit;
        const currentPaginationList = this.state.pageNumbers.slice(indexOfFirstPagination, indexOfLastPagination);  

        return(
            <div className="table-responsive">
                <table className="table table-sm table-striped table-bordered ">
                    <thead>
                        <tr>
                            <th className="text-center" rowSpan="2" colSpan="1">Select<br/><input type="checkbox" onClick={this.onCheckboxSelectAllChange.bind(this)}/></th>
                            <th className="text-center" rowSpan="2" colSpan="1">Cancel</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Item</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Item <br/>Desc</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Part</th>
                            <th className="text-center" rowSpan="1" colSpan="3">Alternate Vendor</th>
                            <th className="text-center" rowSpan="2" colSpan="1">WHSE</th>
                            <th className="text-center" rowSpan="2" colSpan="1">NIPO<br/>Base</th>
                            <th className="text-center" rowSpan="2" colSpan="1">NIPO<br/>Core</th>
                            <th className="text-center" rowSpan="1" colSpan="3">Per Item</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Units<br/>Per Case</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Cases<br/>Per Tier</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Tiers Per<br/>Pallet</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Pallet<br/>Qty</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Company<br/>POQ</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Expiration<br/>Date</th>
                            <th className="text-center" rowSpan="1" colSpan="3">DI Item Vendor</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Major</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Minor</th>
                            <th className="text-center" rowSpan="1" colSpan="3">Primary Vendor</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Order<br/>Pack</th>
                            <th className="text-center" rowSpan="2" colSpan="1">Date And<br/>Timestamp</th>
                        </tr>
                        <tr>
                            <th className="text-center">Number</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Log. Exp</th>
                            <th className="text-center">Available <br/>Inventory</th>
                            <th className="text-center">Annual<br/>Commitment</th>
                            <th className="text-center">Remaining <br/>Available</th>
                            <th className="text-center">MOQ</th>
                            <th className="text-center">MOQ Mult.</th>
                            <th className="text-center">Per PO</th>
                            <th className="text-center">Number</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Log. Exp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.length > 0 ? currentTodos.map((data,key) => {
                            return (
                            <tr key={key} className={data.cancelFlag === 'Y' ? "row-moq-table tableSelected" : "row-moq-table" } >
                                <td className="text-center"><input type="checkbox" checked={data.checked} onChange={e => this.onCheckboxChange(data, key)}/></td>
                                <td className="text-center">{data.cancelFlag === 'N'? 'NO': 'YES'}</td>
                                <td className="text-center alttable-cell-container"><input type="number" name="sku" value={data.sku} className="input-alttable-sku" 
                                onChange={e => this.handleSkuChange(e, data)}/>{data.uploadedData? <i className="material-icons   alttable-cell-warning-upload">warning</i> :data.changeSku === true? <i className="material-icons alttable-cell-warning">warning</i>: null}</td>
                                <td className="text-center"><div className="cell-hidden-name" title={data.itemDescription}>{data.itemDescription}</div></td>
                                <td className="text-center dateTableMoq">{data.partNumber}</td>
                                <td className="text-center alttable-cell-container"><input type="number" name="altVendorNumber" value={data.alternateVendorNumber} className="input-alttable-vendornumber" 
                                onChange={e => this.handleVendorNumberChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeAltVendorNumber === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</td>
                                <td className="text-center"><div className="cell-hidden-name" title={data.alternateVendorName}>{data.alternateVendorName}</div></td>
                                <td className="text-center">{data.alternateVendorLogisticsExport}</td>
                                <td className="text-center "><div className="alttable-cell-container"><input type="number" name="whse" value={data.whse} className="input-alttable-whse" 
                                onChange={e => this.handleWhseChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeWhse === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="nipoBaseCost" value={data.nipoBaseCost} className="input-alttable-nipobase" 
                                onChange={e => this.handleNipoBaseChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeNipoBase === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="nipoCoreCost" value={data.nipoCoreCost} className="input-alttable-nipocore" 
                                onChange={e => this.handleNipoCoreChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeNipoCore === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="availableInventory" value={data.availableInventory} className="input-alttable-availableInv" 
                                onChange={e => this.handleAvailableInventoryChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeAvailableInventory === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="annualCommitment" value={data.annualCommitment} className="input-alttable-annualcommit" 
                                onChange={e => this.handleAnnualCommitmentChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeAnnualCommitment === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="remainingAvailable" value={data.remainingAvailable} className="input-alttable-remainingavail" 
                                onChange={e => this.handleRemainingAvailableChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeRemainingAvailable === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="unitsPerCase" value={data.unitsPerCase} className="input-alttable-unitspercase" 
                                onChange={e => this.handleUnitsPerCaseChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeUnitsPerCase === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="casesPerTier" value={data.casesPerTier} className="input-alttable-casespertier" 
                                onChange={e => this.handleCasesPerTierChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeCasesPerTier === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="tiersPerPallet" value={data.tiersPerPallet} className="input-alttable-tiersperpallet" 
                                onChange={e => this.handlTiersPerPalletChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeTiersPerPallet === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center">{data.palletQuantity}</td>
                                <td className="text-center"><div className="alttable-cell-container"><input type="number" name="companyPOQ" value={data.companyPOQ} className="input-alttable-companypoq" 
                                onChange={e => this.handleCompanyPOQChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeCompanyPOQ === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center dateTableMoq"><div className="alttable-cell-container"><input name="companyPOQ" value={data.expirationDate} className="input-alttable-expirationDate" 
                                onChange={e => this.handleExpirationDateChange(e, data)}/>{data.uploadedData? <i className="material-icons  alttable-cell-warning-upload">warning</i> :data.changeExpirationDate === true? <i className="material-icons alttable-cell-warning">warning</i>: ''}</div></td>
                                <td className="text-center">{data.diItemVendorMoq}</td>
                                <td className="text-center">{data.diItemVendorDCMoq}</td>
                                <td className="text-center">{data.diItemVendorMoqPerPO}</td>
                                <td className="text-center">{data.major}</td>
                                <td className="text-center">{data.minor}</td>
                                <td className="text-center">{data.primaryVendorNumber}</td>
                                <td className="text-center"><div className="cell-hidden-name" title={data.primaryVendorName}>{data.primaryVendorName}</div></td>
                                <td className="text-center">{data.primaryVendorLogisticsExport}</td>
                                <td className="text-center">{data.orderPack}</td>
                                <td className="text-center dateTableMoq">{data.dateAndTimestamp}</td>
                            </tr>
                            )
                        }) : <tr></tr>
                        }
                    </tbody>
                </table>
                <Pagination aria-label="Table navigation" className="pagination">
                    <PaginationItem>
                        <PaginationLink first  onClick={e => {this.handleClickPagination('first')}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink previous onClick={e => {this.handleClickPagination(-1)}}/>
                    </PaginationItem>
                    {this.state.data.length > 0 ? currentPaginationList.map((data, key) => {
                        return (
                            <PaginationItem key={key}>
                                <PaginationLink onClick={e => this.handleClick(data)}>
                                    {data}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    }): <div></div>
                    }
                    <PaginationItem>
                        <PaginationLink  next onClick={e => {this.handleClickPagination(1)}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink last onClick={e => {this.handleClickPagination('last')}}/>
                    </PaginationItem>
                </Pagination>  
                <p>Total Rows: {this.state.data.length}</p> 
            </div>

        );
    }


}

export default AltVendorTable;